export const LOAN_MAX_DAYS_PAST_DUE = 120;
